import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { BackendModule } from '@shared/datastore/core';
import { projectsBackend } from './projects.backend';
import { projectsReducer } from './projects.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature('projects', projectsReducer),
    BackendModule.forFeature('projects', projectsBackend),
  ],
})
export class DatastoreProjectsModule {}



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/projects/projects.module.ts